module.exports = __webpack_public_path__ + "static/logo-lcef-big@2x-befef67d2be64b19643dfbeceb02dd4d.png";